import { utils, records } from '@ims/1edtech-frontend-common'

import { getRecord } from 'lib/records/workflows/getRecord'
import store from 'lib/store'
import { OR_CSV_CHARACTERIZATIONS_RECORD } from 'lib/records/modules/orCSVCharacterizations'
import ICharacterization from 'domains/characterizations/models/ICharacterization'
import { ONEROSTER_CSV_CHARACTERIZATION_REPORTS_RECORD } from 'lib/records/modules/oneRosterCSVCharacterizationReports'

export const getFullCSVCharacterization = async (id: string | number) => {
  await getRecord(OR_CSV_CHARACTERIZATIONS_RECORD, id)
  const characterization: ICharacterization = records.entitiesSelectors.entityByIdSelector(
    OR_CSV_CHARACTERIZATIONS_RECORD,
    utils.convertToInt(id),
  )(store.getState())
  if (!characterization) {
    return
  }
  await getRecord(
    ONEROSTER_CSV_CHARACTERIZATION_REPORTS_RECORD,
    characterization.content,
  )
}
